import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'service-not-selected-dialog',
    templateUrl: './serviceNotSelectedDialog.component.html',
    styleUrls: ['./serviceNotSelectedDialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ServiceNotSelectedDialogComponent {
    constructor(
        public matDialogRef: MatDialogRef<ServiceNotSelectedDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
    ) {

    }

}
